class AlgoliaIconPlus extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      defaultIconPlusUrl: this.getAttribute('default-icon-plus-url'),
      iconPlusSize: this.getAttribute('icon-plus-size'),
      iconPlusUrl: this.getAttribute('icon-plus-url')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      .icon-plus {
        background-image: url(${this.settings.iconPlusUrl ? this.settings.iconPlusUrl : this.settings.defaultIconPlusUrl});
        background-position: center;
        background-repeat: no-repeat;
        background-size: ${this.settings.iconPlusSize}%;
        height: 100%;
        width: 100%;
      }
    `;

    style.appendChild(document.createTextNode(css));

    return style;
  }

  /**
   * Renders the icon content.
   * @returns {string} The rendered icon.
   */
  render() {
    const style = this.getStyle();
    const div = document.createElement('div');
    div.className = 'icon-plus';
    div.setAttribute('aria-hidden', 'true');
    div.setAttribute('focusable', 'false');
    div.textContent = ' ';
    
    return [style, div];
  }
}

customElements.define("algolia-icon-plus", AlgoliaIconPlus);